import { render, staticRenderFns } from "./PromptAssistantDialog.vue?vue&type=template&id=0aea97b4&scoped=true&"
import script from "./PromptAssistantDialog.vue?vue&type=script&lang=js&"
export * from "./PromptAssistantDialog.vue?vue&type=script&lang=js&"
import style0 from "./PromptAssistantDialog.vue?vue&type=style&index=0&id=0aea97b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aea97b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VIcon})
